module.exports = __webpack_public_path__ + "assets/img/cai_bg_fractal_dots2.48431600.png";